import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import enTranslations from './translations/en.json';
import koTranslations from './translations/ko.json';
import jpTranslations from './translations/jp.json';
import zhCNTranslations from './translations/zh-CN.json';
import zhTWTranslations from './translations/zh-TW.json';

i18n.use(initReactI18next).init({
    resources: {
        en: {
            translation: enTranslations,
        },
        ko: {
            translation: koTranslations,
        },
        ja: {
            translation: jpTranslations,
        },
        'zh-CN': {
            translation: zhCNTranslations,
        },
        'zh-TW': {
            translation: zhTWTranslations,
        },
    },
    lng: 'ko',
    fallbackLng: 'ko',
    interpolation: {
        escapeValue: false,
    },
});

export default i18n;
